import React from 'react'
import { ReactSVG } from 'react-svg'
import * as styles from './Link.module.scss'

interface BaseLinkProps {
  variant?: 'dark' | 'light'
  disabled?: boolean
  showLeadIcon?: boolean
  showTrailIcon?: boolean
  leadIconSrc?: string
  trailIconSrc?: string
  className?: string
  display?: 'block' | 'inlineBlock' | 'inline' | 'inlineFlex' | 'flex'
  textDecoration?: 'none' | 'underline'
}

export type LinkProps = BaseLinkProps &
  React.AnchorHTMLAttributes<HTMLAnchorElement>

export const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(
  (
    {
      children,
      disabled = false,
      className = '',
      variant = 'dark',
      display = 'flex',
      showLeadIcon = false,
      showTrailIcon = false,
      leadIconSrc = '/img/icons/chevron-left.svg',
      trailIconSrc = '/img/icons/chevron-right.svg',
      href,
      textDecoration = 'none',
      ...props
    },
    ref
  ) => {
    return (
      <a
        className={`${styles.link} ${styles[variant]} ${className} ${styles[display]} ${styles[textDecoration]}`}
        ref={ref}
        href={href}
        {...props}
      >
        {showLeadIcon && (
          <span>
            <ReactSVG src={leadIconSrc} />
          </span>
        )}
        <span>{children}</span>
        {showTrailIcon && (
          <span>
            <ReactSVG src={trailIconSrc} />
          </span>
        )}
      </a>
    )
  }
)

export default Link
